/** Detect Golf Homes client views for themed portal experiences. */
export function isGolfHomesView(view) {
  if (!view) return false;
  const slug = String(view.slug || "").toLowerCase();
  const type = String(view.viewType || view.view_type || "").toLowerCase();
  const name = String(view.name || "").toLowerCase();
  return (
    type === "golf_homes" ||
    slug.includes("golf-homes") ||
    slug.includes("golf_homes") ||
    name.includes("golf homes")
  );
}

export function isMidpointMediaView(view) {
  if (!view) return false;
  const slug = String(view.slug || "").toLowerCase();
  const type = String(view.viewType || view.view_type || "").toLowerCase();
  const name = String(view.name || "").toLowerCase();
  return (
    slug === "midpoint-media" ||
    slug.includes("midpoint-media") ||
    type === "midpoint_media" ||
    name === "midpoint media"
  );
}

export function isHiringOpportunity(opportunity) {
  const type = String(opportunity?.opportunityType || "").toLowerCase();
  const leadType = String(opportunity?.leadType || "").toLowerCase();
  return (
    leadType === "job_application" ||
    leadType === "careers_application" ||
    type.includes("hiring") ||
    type.includes("careers") ||
    type.includes("job")
  );
}

export function formatMidpointMediaOpportunityStatus(status) {
  const value = String(status || "").toLowerCase();
  if (value === "under_contract") return "In progress";
  if (value === "assigned" || value === "qualified") return "Reviewing";
  if (value === "closed_won" || value === "won" || value === "completed") return "Hired / Won";
  if (!status) return "—";
  return status
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
